export default "__VITE_ASSET__pGUCp4M8__"